import React from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../store/actions';
import useRouter from '../../../../hooks/useRouter';

const TableLinkRenderer = (params) => {
  const dispatch = useDispatch(); // <-- Get the dispatch function
  const router = useRouter();

  let url = params.url;
  if (url && !url.startsWith('/')) {
    url = '/' + url;
  }
  const assetName = params.value;

  const navigateAlert = () => {
    dispatch(actions.toggleAlertMenu())
    router.push(url);
  };

    return <a onClick={() => navigateAlert()}>{assetName}</a>;
};

export default TableLinkRenderer;
